import { useTranslation } from 'react-i18next';
import ClientTourCard from './ClientTourCard';

const ClientTourGrid = ({
    tours,
    hasActiveFilters,
    openImageViewer,
    copyLink,
    handleEditClick,
    handleStatusChange,
    handleDeleteTour,
    cities,
    propertyTypes
}) => {
    const { t } = useTranslation();

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {(tours || []).map(tour => (
                <ClientTourCard
                    key={tour.id}
                    tour={tour}
                    openImageViewer={openImageViewer}
                    copyLink={copyLink}
                    handleEditClick={handleEditClick}
                    handleStatusChange={handleStatusChange}
                    handleDeleteTour={handleDeleteTour}
                    cities={cities}
                    propertyTypes={propertyTypes}
                />
            ))}
            {tours.length === 0 && (
                <div className="col-span-full text-center py-12">
                    <p className="text-gray-500 text-lg">
                        {hasActiveFilters ? t('noToursFound') : t('noTours')}
                    </p>
                </div>
            )}
        </div>
    );
};

export default ClientTourGrid;
